import i18next from 'i18next';

const namespace = 'forgotPassword';
const config = {
  zh: {
    Login: '登录',
    'Forgot Password': '忘记密码',
    'Verify E-mail Address': '输入邮箱地址',
    'Verify Authentication': '验证邮箱',
    'Reset Password': '设置新密码',
    Complete: '完成',
  },
  en: {
    Login: 'Login',
    'Forgot Password': 'Forgot Password',
    'Verify E-mail Address': 'Verify E-mail Address',
    'Verify Authentication': 'Verify Authentication',
    'Reset Password': 'Reset Password',
    Complete: 'Complete',
  },
};

Object.keys(config).forEach((key) => {
  i18next.addResources(key, namespace, config[key]);
});
